import React from 'react'

const ListingDetailsSection = (props) => {
    return (
        <>
            <div className="col-11 col-md-5 border-bottom border-1 border-white mb-2 fw-300">
                <div className="d-flex">
                    <div className="">{props.Title1}</div>
                    <div className="ms-auto">{props.Title2}</div>
                </div>
            </div>
        </>
    )
}

export default ListingDetailsSection
